import { gmapApi } from 'vue2-google-maps'

export default {
  name: 'wms-layer',
  inject: {
    $mapPromise: {
      default: null
    }
  },
  props: {
    layer: {
      type: Object,
      required: true
    },
    zIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      tileLayer: null,
      mapObject: null
    }
  },
  computed: {
    google: gmapApi,
    currentOpacity() {
      const layerId = this.layer.layer;
      if (this.$store && this.$store.state.ui && this.$store.state.ui.layers_opacities && layerId) {
        return this.$store.state.ui.layers_opacities[layerId] || 35;
      }
      return typeof this.layer.opacity === 'number' ? this.layer.opacity : 35;
    }
  },
  mounted() {
    this.$mapPromise.then(map => {
      this.mapObject = map
      this.createTileLayer()
    })
  },
  beforeDestroy() {
    if (this.tileLayer && this.mapObject) {
      const overlays = this.mapObject.overlayMapTypes
      for (let i = 0; i < overlays.getLength(); i++) {
        if (overlays.getAt(i) === this.tileLayer) {
          overlays.removeAt(i)
          break
        }
      }
    }
  },
  watch: {
    currentOpacity(newVal) {
      if (this.tileLayer) {
        this.tileLayer.setOpacity(newVal/100)
      }
    }
  },
  methods: {
    createTileLayer() {

      this.$store.dispatch('layer_loaded', this.layer.layer);
      
      if (!this.mapObject || !this.google) {
        return
      }

      try {
        const getTileUrl = (coord, zoom) => {
          // Extraire la version et le CRS/SRS de l'URL WMS
          const url = this.layer.url;
          const getParam = (param) => {
            const regex = new RegExp(`[?&]${param}=([^&#]*)`, 'i');
            const match = url.match(regex);
            return match ? match[1] : null;
          };
          
          const version = getParam('VERSION') || getParam('version');
          const srs = getParam('CRS') || getParam('SRS') || getParam('crs') || getParam('srs');
          
          // Convertir les coordonnées de tuile en coordonnées mondiales
          const scale = Math.pow(2, zoom);
          const worldCoordinate = {
            x: coord.x / scale,
            y: coord.y / scale
          };
          
          // Taille d'une tuile en degrés
          const tileSize = 360 / scale;
          
          // Calculer les limites de la tuile en degrés (EPSG:4326)
          const west = worldCoordinate.x * 360 - 180;
          const east = west + tileSize;
          const north = Math.atan(Math.sinh(Math.PI * (1 - 2 * worldCoordinate.y))) * 180 / Math.PI;
          const south = Math.atan(Math.sinh(Math.PI * (1 - 2 * (worldCoordinate.y + 1 / scale)))) * 180 / Math.PI;
          
          // Formater avec 6 décimales maximum
          const formatCoord = (coord) => parseFloat(coord.toFixed(6));
          
          let bbox;
          if ((version && parseFloat(version) >= 1.3) && (srs === 'EPSG:4326' || srs === 'EPSG%3A4326')) {
            // WMS 1.3.0 et versions supérieures avec EPSG:4326 utilisent lat,lng (sud,ouest,nord,est)
            bbox = `${formatCoord(south)},${formatCoord(west)},${formatCoord(north)},${formatCoord(east)}`;
          } else {
            // WMS 1.1.1 et autres SRS utilisent lng,lat (ouest,sud,est,nord)
            bbox = `${formatCoord(west)},${formatCoord(south)},${formatCoord(east)},${formatCoord(north)}`;
          }
          
          // Construire l'URL finale avec le BBOX calculé
          return this.layer.url
            .replace('{bbox}', bbox)
            .replace('{w}', '256')
            .replace('{h}', '256');
        }

        const options = {
          getTileUrl,
          tileSize: new this.google.maps.Size(256, 256),
          opacity: this.currentOpacity/100,
        }

        this.tileLayer = new this.google.maps.ImageMapType(options)

        // Le zIndex n'est pas disponible sur les overlayMapTypes, on doit donc le calculer et jouer avec les index
        const zIndex = this.mapObject.overlayMapTypes.getLength();
        this.mapObject.overlayMapTypes.insertAt(zIndex, this.tileLayer)
      } catch (error) {
      }
    }
  },
  render() {
    return null // Ce composant ne rend aucun élément DOM
  }
}